import { hcpDocumentAttributesSchema } from "@src/appV2/Accounts/Documents/types";
import { API_TYPES } from "@src/appV2/api/constants";
import { z } from "zod";

import { HelloSignWorkflowSessionStatus } from "./constants";

export const getHelloSignSessionQueryParamsSchema = z.object({
  include: z.literal(API_TYPES.documents).optional(),
});

export type GetHelloSignSessionQueryParams = z.infer<typeof getHelloSignSessionQueryParamsSchema>;

export const helloSignSessionAttributesSchema = z.object({
  signUrl: z.string().optional(),
  status: z.nativeEnum(HelloSignWorkflowSessionStatus),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type HelloSignSessionAttributes = z.infer<typeof helloSignSessionAttributesSchema>;

export const helloSignSessionResponseSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.helloSignSession),
    attributes: helloSignSessionAttributesSchema,
    id: z.string(),
    relationships: z.object({
      document: z
        .object({
          data: z.object({
            id: z.string(),
            type: z.literal(API_TYPES.documents),
          }),
        })
        .optional(),
      requirement: z.object({
        data: z.object({
          id: z.string(),
          type: z.literal("requirements"),
        }),
      }),
    }),
  }),
  included: z
    .array(
      z.object({
        type: z.literal(API_TYPES.documents),
        id: z.string(),
        attributes: hcpDocumentAttributesSchema,
      })
    )
    .optional(),
});

export type HelloSignSessionResponse = z.infer<typeof helloSignSessionResponseSchema>;
